import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseResponse } from "app/business/common/baseresponse";
import { LookUpItem } from "app/business/common/lookupitem";
import { tblBankDetail } from "app/models/user/tblbankdetail";
import { UserApplication } from "app/models/userapplication/userapplication";
import { environment } from "environments/environment";

@Injectable({
    providedIn: "root",
})
export class UserApplicationService {
    constructor(private http: HttpClient) { }

    async getUserApplication(input: any): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/UserApplication/GetUserApplications`, input)
            .toPromise() as BaseResponse;
    }

    async addUserApplication(user: UserApplication): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/UserApplication/AddUserApplication`, user)
            .toPromise() as BaseResponse;
    }

    async updateUserApplication(user: UserApplication): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/UserApplication/UpdateUserApplication`, user)
            .toPromise() as BaseResponse;
    }

    async deleteUserApplication(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/UserApplication/DeleteUserApplication/' + userId)
            .toPromise() as BaseResponse;
    }

    async getUserApplicationById(userId: string): Promise<BaseResponse> {
        if (!userId || userId === 'undefined') {
            const errorResponse = new BaseResponse();
            errorResponse.status = -1;
            errorResponse.message = "User ID is required";
            return errorResponse;
        }
        return await this.http.get(environment.apiUrl + '/UserApplication/GetUserApplicationById/' + userId)
            .toPromise() as BaseResponse;
    }

    async getUserApplicationDocument(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/UserApplication/GetUserApplicationDocument/' + userId)
            .toPromise() as BaseResponse;
    }

    async saveUserApplicationDocument(userId: string, files?: { files?: File[], documentIds?: number[], fileUrls?: string[] }): Promise<BaseResponse> {
        var fd = new FormData();
        fd.append("data", JSON.stringify(userId));

        if (files && files.files && files.files.length > 0) {
            for (let i = 0; i < files.files.length; i++) {
                fd.append("files", files.files[i]);
            }
        }
        if (files && files.documentIds && files.documentIds.length > 0) {
            fd.append("documentIds", JSON.stringify(files.documentIds));
        }

        if (files && files.fileUrls && files.fileUrls.length > 0) {
            fd.append("fileUrls", JSON.stringify(files.fileUrls));
        }

        return await this.http.post(environment.apiUrl + '/UserApplication/SaveUserApplicationDocument', fd)
            .toPromise() as BaseResponse;
    }

    async getUserApplicationBankDetail(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/UserApplication/GetUserApplicationBankDetail/' + userId)
            .toPromise() as BaseResponse;
    }

    async saveUserApplicationBankDetail(bankDetail: tblBankDetail, file?: { file?: File, fileUrl?: string }): Promise<BaseResponse> {
        var fd = new FormData();
        fd.append("data", JSON.stringify(bankDetail));

        if (file && file.file) {
            fd.append("file", file.file);
        }

        if (file && file.fileUrl) {
            fd.append("fileUrl", file.fileUrl);
        }

        return await this.http.post(environment.apiUrl + '/UserApplication/SaveUserApplicationBankDetail', fd)
            .toPromise() as BaseResponse;
    }

    async updateUserApplicationStatus(userId: string, status: number): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/UserApplication/UpdateUserApplicationStatus/' + userId + '/' + status)
            .toPromise() as BaseResponse;
    }

    async checkEmailExistInUserApplication(lookup: LookUpItem): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/UserApplication/CheckEmailExistInUserApplication`, lookup)
            .toPromise() as BaseResponse;
    }

    async checkMobileExistInUserApplication(lookup: LookUpItem): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/UserApplication/CheckMobileExistInUserApplication`, lookup)
            .toPromise() as BaseResponse;
    }

}
